module.exports = __webpack_public_path__ + "img/documents-unselected.9c5c6176.svg";